"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (userId, range) => `query {
                    progressCollection(range: {from: "${range.from}",to: "${range.to}"}, userId: ${userId}) {
                        dayType
                    }
                }`;
//# sourceMappingURL=getDaysType.js.map